import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  background: var(--background-white-n-0, #fff);
  position: relative;
  z-index: 1;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #f5f5f7;
  border-radius: 8px;
  flex-shrink: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const LabelText = styled.div`
  color: var(--Neutral-N500, #36354c);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
  text-transform: uppercase;
`;

export const DateTimeText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2c2c3a;
  line-height: 22px;
`;
